import { useAuthStore } from '@/context/authStore';
import { FlaskConical, Clock, FileText, TestTube } from 'lucide-react';

export default function LabDashboard() {
  const { user, tenant } = useAuthStore();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          Bienvenido, {user?.full_name}
        </h1>
        <p className="text-gray-600">
          Panel de Laboratorio - {tenant?.name || 'ANIMA Lab'}
        </p>
      </div>

      {/* Placeholder Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white rounded-xl shadow-sm border border-lab-100 p-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-lab-100 rounded-xl flex items-center justify-center">
              <TestTube className="h-6 w-6 text-lab-600" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Muestras Pendientes</p>
              <p className="text-2xl font-bold text-gray-900">-</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-lab-100 p-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-lab-200 rounded-xl flex items-center justify-center">
              <Clock className="h-6 w-6 text-lab-700" />
            </div>
            <div>
              <p className="text-sm text-gray-500">En Proceso</p>
              <p className="text-2xl font-bold text-gray-900">-</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-lab-100 p-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
              <FileText className="h-6 w-6 text-green-600" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Completados Hoy</p>
              <p className="text-2xl font-bold text-gray-900">-</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-lab-100 p-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-lab-100 rounded-xl flex items-center justify-center">
              <FlaskConical className="h-6 w-6 text-lab-600" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Total del Mes</p>
              <p className="text-2xl font-bold text-gray-900">-</p>
            </div>
          </div>
        </div>
      </div>

      {/* Coming Soon Section */}
      <div className="bg-white rounded-xl shadow-sm border border-lab-200 p-8 text-center">
        <FlaskConical className="h-16 w-16 text-lab-500 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          ANIMA Lab - En Desarrollo
        </h2>
        <p className="text-gray-600 max-w-lg mx-auto">
          El modulo de laboratorio esta en desarrollo. Pronto podras gestionar
          muestras, resultados de analisis y reportes desde esta plataforma.
        </p>
      </div>
    </div>
  );
}
